import React, { ReactNode } from 'react';
import { SeverityLabels } from '@fabric-ui/components';
import type { EntityConfigType } from '@utils/entityViewConfig';

export enum EVariant {
  default = 'default',
  values = 'values',
  transition = 'transition',
  percentage = 'percentage',
}

export interface ISummarizedCollapse {
  items: ISummarizedCollapseItem[];
  hideDivider?: boolean;
}

export interface ISummarizedCollapseItem {
  title: string;
  data?: any[];
  showPills?: boolean;
  getPillsStyleFunc?: (key, data) => Record<any, any>;
  getLabelFunc?: (key: any) => any;
  isLoading?: boolean;
  onSuccess?: (data?: any) => any;
  showIcon?: boolean;
  variant?: EVariant;
  icon?: ReactNode;
}

export interface IEntityViewChartsProps {
  filters: Record<string, any>;
  isExpanded?: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  entityTypeId: string;
  extraFilters?: string[];
  searchFields?: string[];
}

export type AbstractSeverityBarItem = {
  severity: SeverityLabels;
  isCurrent?: boolean;
};

export type ISeverityBarItemValue = { value: number; height: number };

export interface ISeverityCompareWidget {
  data?: Omit<AbstractSeverityBarItem & { prev: ISeverityBarItemValue; now: ISeverityBarItemValue }, 'isCurrent'>[];
  entityTypeId: EntityConfigType['entityTypeId'];
}

export interface ITooltipContent {
  severity: SeverityLabels;
  prev: { value: number; height: number };
  now: { value: number; height: number };
  entityTypeId: EntityConfigType['entityTypeId'];
  isNewRiskScoreEnabled?: boolean;
}
